import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

interface TSpinnerStylesProps {
  color?: string;
}

export const useStyles = (props: TSpinnerStylesProps) => {
  const color = computed(() => props.color);

  const theme = useTheme();
  const baseClass = computed(() => css({
    margin: 0,
    padding: 0,
    width: '3.5rem',
    height: '3.5rem',
    boxSizing: 'border-box',
    background: 'transparent',
    borderRadius: '50%',
    border: `0.5rem solid ${theme.value.colors.background}`,
    borderBottomColor: color.value ?? theme.value.colors.primary.main,
    animation: 'rotate 0.75s linear infinite',
    '&--medium': {
      width: '4.5rem',
      height: '4.5rem',
    },
    '&--auto': {
      [`@media (min-width: ${theme.value.breakpoints.desktop}px)`]: {
        width: '4.5rem',
        height: '4.5rem',
      },
    },
    '@keyframes rotate': {
      '0%': {
        transform: 'rotate(0deg)',
      },
      '100%': {
        transform: 'rotate(360deg)',
      },
    },
  }));

  return baseClass;
};
